(function($) {
  $(function() {
    var
      $body = $('body'),
      country = $body.data('country') ? $body.data('country') : 'fr'
    ;

    // Init linkify
    require('linkifyjs/jquery')($, document);
    $('.linkify').linkify();

    // Init Fancybox
    require('fancybox/dist/js/jquery.fancybox.cjs.js')($);
    $('.fancybox').fancybox();

    /*
     * JQUERY VALIDATE.
     * - Javascript form validation before submit.
     */
    if ('undefined' !== typeof $.fn.validate && $.isFunction($.fn.validate)) {
      /*
       * Configure jquery validate for Bootstrap 3.
       */
      $.validator.setDefaults({
        'ignore': ':hidden:not([name*="captcha"])',
        'highlight': function(element) {
          // Add the .has-error class to the form-group.
          $(element).closest('.form-group').addClass('has-error');
        },
        'unhighlight': function(element) {
          // Remove the .has-error class from the form-group.
          $(element).closest('.form-group').removeClass('has-error');
        },
        'errorElement': 'p',
        'errorClass': 'help-block',
        'errorPlacement': function(error, element) {
          // Handle the error placement for checkbox & radio.
          if (element.parent('.input-group').length || 'checkbox' === element.prop('type') || 'radio' === element.prop('type')) {
            error.appendTo(element.parent());
          } else {
            error.insertAfter(element);
          }
        }
      });

      // Add a polyfill method to test custom regexp against user input.
      $.validator.addMethod('cemail', function(value, element, regexp)  {
        regexp = new RegExp(/\b[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}\b/i);

        return this.optional(element) || regexp.test(value);
      }, 'Please enter a valid email address');

      $.validator.addMethod('pattern', function(value, element, regexp)  {
        var pattern = new RegExp(regexp);

        return this.optional(element) || pattern.test(value);
      });

      // $.validator.addMethod('alphanumeric', function(value, element) {
      //   var regexp = new RegExp(/^[\u4e00-\u9fff_A-Za-zа-яёЁÀ-Ÿ][\u4e00-\u9fff_a-zа-яёЁÀ-Ÿ0-9\-\s]+$/i);

      //   return regexp.test(value);
      // }, 'Letters, numbers, spaces or dashes only');

      /*
       * Enable jquery-validate for all matching (not just the first) using a each() closure in case there's two form on
       * the same page, eg. sidebar and footer.
       */
      $('.js-contact-form, .js-newsletter-form').each(function(i, e) {
        $(e).validate({
          'rules': {
            'front_message_type[email]': {
              'email': false,
              'cemail': true
            },
            'front_newsletter_type[email]': {
              'email': false,
              'cemail': true
            }
          }
        });
      });

      $('.max_length_rule').each(function() {
        $(this).rules('add', {
          maxlength: 100,
          alphanumeric: true,
          messages: {
            maxlength: $(this).data('msg-error')
          }
        })
      })

      $('.email_rule').each(function() {
        $(this).rules('add', {
          email: false,
          cemail: true,
          messages: {
            maxlength: $(this).data('msg-error')
          }
        })
      })
    }

    /**
     * MATCH HEIGHT.
     * - Make sure Bootstrap 3 grid does not explode because of various thumbnail/col-* heights.
     */
    $('.match-height .thumbnail.grid').not('.file-icon').matchHeight({
      byRow: false
    });
    $('.js-match-height .card').matchHeight();

    $('.js-match-height .js-match-height-item').matchHeight();

    $('.js-buckle--spokesperson').on('ajaxComplete.jq.buckle', function (event) {
      var
        $element = event.buckle.getElement(),
        $container = event.buckle.getContainer()
      ;

      MatchHeightHelper.update($container[0], true, '.js-match-height .card');
    });

    $('.js-buckle--assets').on('showing.jq.offie-dropdown', '[data-toggle="offie-dropdown"]', function (event) {
      var buckle = $(event.target).closest('.js-buckle--folder').data('buckle');

      // Fetch content of the folder.
      buckle.fetch({});
    });

    $('.js-buckle--assets').on('ajaxComplete.jq.buckle', function (event) {
      var
        $element = event.buckle.getElement(),
        $container = event.buckle.getContainer()
      ;

      // Update the grid.
      MatchHeightHelper.update($container[0], true, '.js-match-height .card');

      // Enable any child buckle component (folders).
      $element.find('[data-toggle="buckle"]').buckle();

      // Enable any offie dropdown component (folders).
      $element.find('[data-toggle="offie-dropdown"]').offieDropdown();
    });

    // Datetimepicker
    var dateTimePickerOptions = {
      'format': 'yyyy-mm-dd',
      'startView': 'year',
      'minView': 'month',
      'fontAwesome': true,
      'autoclose': true
    };

    $('#front_search_type_start').datetimepicker(dateTimePickerOptions);
    $('#front_search_type_end').datetimepicker(dateTimePickerOptions);

    $('#front_filter_type_start').datetimepicker(dateTimePickerOptions);
    $('#front_filter_type_end').datetimepicker(dateTimePickerOptions);

    require('./modules/share.js');

    // Didomi - Display Banner
    let didomiBtn = document.getElementById('didomi-banner-btn') ?? null;
    if (didomiBtn != null) {
      didomiBtn.addEventListener('click', function() {
        window.Didomi?.preferences.show();
      });
    }

    $('.js-buckle--client-investors-api').on('success.jq.buckle', (event) => {
      const data = event?.responseData?.flux?.element_du_jour;

      if (data && typeof data.derniers_cours !== 'undefined') {
        event.buckle
          .getElement()
          .find('.share-price')
          .text(data.derniers_cours + '€');
      }
    });

    $('.navbar-mobile-box .group-line-burger').on('click', function() {
      let $this = $(this);
      let isActive = $this.parent().hasClass('active');

      if (isActive) {
        $('body').css('overflow', 'inherit');
        $this.parent().removeClass('active');
      } else {
        $this.parent().addClass('active');
        $('body').css('overflow', 'hidden');
      }
    });

    const $searchContainer = $('#offie--search-custom');
    const $searchForm = $('.search-form-custom');
    const $searchInput = $('#search-input');
    const clientSearchUrl = $searchContainer.data('url') || '#';

    $('.block-views .btn-close-form').on('click', function() {
      $searchInput.val('');
      $('.mask-wrapper .btn-search .navbar-knob--search')[0].click();
      $('body').removeClass('search-opened');
      $('body').css('overflow', 'inherit');
    });

    $('.navbar-mobile-box .navbar-knob--search').on('click', function() {
      $('body').addClass('search-opened');
      $('body').css('overflow', 'hidden');
    });

    function performSearch(event) {
      event.preventDefault();
      const searchTerm = $searchInput.val().trim();
      if (searchTerm && clientSearchUrl !== '#') {
        const encodedSearchTerm = searchTerm.replace(/\s/g, '%20');
        window.location.href = `${clientSearchUrl}${encodedSearchTerm}`;
      }
    }

    $searchForm.on('submit', performSearch);

    function assetCenterMode() {
      const section = $('.section--news-alt');
      const carouselInner = section.find('.gallery-list');
      let items = carouselInner.find('.gallery-item');
      let totalItems = items.length;

      if (totalItems < 4) return;

      let currentIndex = 0;
      const cloneCount = 2;
      let itemWidth = items.outerWidth(true);
      let isAnimating = false;

      for (let i = 0; i < cloneCount; i++) {
        const nextClone = items.eq(i).clone(true, true).addClass('cloned');
        carouselInner.append(nextClone);
      }

      function recalcWidth() {
        items = carouselInner.find('.gallery-item');
        itemWidth = items.outerWidth(true);
      }

      function setTransform(index) {
        carouselInner.css('transform', `translateX(${-itemWidth * index}px)`);
      }

      function setTransition(enable) {
        carouselInner.css('transition', enable ? 'transform 0.5s ease-in-out' : 'none');
      }

      function updateButtons() {
        section.find('.btn-prev').toggleClass('disabled', currentIndex === 0);
        section.find('.btn-next').removeClass('disabled');
      }

      function updateCarousel(isNext = true) {
        if (isAnimating) return;
        isAnimating = true;

        if (isNext) {
          currentIndex++;
        } else if (currentIndex > 0) {
          currentIndex--;
        }

        updateButtons();
        setTransition(true);
        setTransform(currentIndex);

        carouselInner.one('transitionend', function () {
          if (currentIndex >= totalItems) {
            currentIndex = 0;
            setTransition(false);
            setTransform(currentIndex);
          }
          updateButtons();
          isAnimating = false;
        });
      }

      function setupNavigationButtons() {
        section.find('.btn-next').on('click', function () {
          if (!$(this).hasClass('disabled')) {
            updateCarousel(true);
          }
        });

        section.find('.btn-prev').on('click', function () {
          if (!$(this).hasClass('disabled')) {
            updateCarousel(false);
          }
        });
      }

      setTransform(currentIndex);
      setupNavigationButtons();
      updateButtons();

      $(window).on('resize', function () {
        recalcWidth();
        setTransition(false);
        setTransform(currentIndex);
      });
    }

    setTimeout(() => {
      assetCenterMode();
    }, 300);

    function setProperty() {
      let vh = window.innerHeight * 0.01
      document.documentElement.style.setProperty('--vh', `${vh}px`)

      window.addEventListener('resize', () => {
        vh = window.innerHeight * 0.01
        document.documentElement.style.setProperty('--vh', `${vh}px`)
      })
    }

    setProperty();

    const selectEl = document.querySelector('#front_filter_type_tags');
    if (!selectEl || !selectEl.tomselect) return;

    const ts = selectEl.tomselect;

    if (ts._clickOutsideHandler) {
      document.removeEventListener('click', ts._clickOutsideHandler);
      ts._clickOutsideHandler = null;
    }

    const originalDocumentClick = ts.onDocumentClick;
    ts.onDocumentClick = function (e) {
      const target = e.target;

      if (ts.control.contains(target) || target === ts.control) {
        if (ts.isOpen) {
          ts.close();
        } else {
          ts.open();
        }
        return;
      }

      if (ts.dropdown.contains(target)) {
        return;
      }
      return false;
    };

    const originalBlur = ts.onBlur;
    ts.onBlur = function (e) {
      if (e && e.relatedTarget && ts.dropdown.contains(e.relatedTarget)) {
        return;
      }
    };

    const searchInput = ts.control.querySelector('input[type="text"]');
    if (searchInput) {
      searchInput.setAttribute('readonly', 'readonly');
    }

    const urlParams = new URLSearchParams(window.location.search);
    const hasFilter = [...urlParams.keys()].some(k => k.startsWith('tags[')) || urlParams.has('start') || urlParams.has('end');
  
    if (hasFilter) {
      ts.open();
      const tags = [];
      for (const [key, value] of urlParams.entries()) {
        if (key.startsWith('tags[')) {
          const tag = decodeURIComponent(value).trim();
          if (ts.options[tag]) {
            tags.push(tag);
          }
        }
      }

      if (tags.length > 0) {
        ts.setValue(tags);
      }
    }

    ts.control.addEventListener('click', function (e) {
      e.stopPropagation();
      if (ts.isOpen) {
        ts.close();
      } else {
        ts.open();
      }
    });

    ts.dropdown.addEventListener('click', function (e) {
      e.stopPropagation();
    });
  });
}(jQuery));
